/* tslint:disable */
/* eslint-disable */
/**
 * API Explorer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const QuoteStatus = {
    Undefined: 0,
    Active: 1,
    Closed: 2,
    Expired: 3,
    Refunded: 4,
    Canceled: 5,
    Chargeback: 6
} as const;

export type QuoteStatus = typeof QuoteStatus[keyof typeof QuoteStatus];



